import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { createContext, createElement } from 'react';
import * as Icons from '@remirror/icons';
import { jsx, jsxs } from 'react/jsx-runtime';

/**
 * @module
 *
 * Taken from
 * https://github.com/react-icons/react-icons/blob/10199cca7abeb3efbc647090714daa279da45779/packages/react-icons/src/iconContext.tsx#L1-L19
 */
var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = /*#__PURE__*/createContext(DefaultContext);
IconContext.Provider;

var _excluded = ["title"];

function Tree2Element(tree) {
  return tree.map((node, index) => {
    var _node$child;

    return /*#__PURE__*/createElement(node.tag, _objectSpread({
      key: index
    }, node.attr), Tree2Element((_node$child = node.child) !== null && _node$child !== void 0 ? _node$child : []));
  });
}
/**
 * A higher order component which creates the Icon component.
 */


function GenIcon(tree) {
  var viewBox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0 0 24 24';
  // eslint-disable-next-line react/display-name
  return props => /*#__PURE__*/jsx(IconBase, _objectSpread(_objectSpread({
    viewBox: viewBox
  }, props), {}, {
    children: Tree2Element(tree !== null && tree !== void 0 ? tree : [])
  }));
}

/**
 * Dynamic icons for the remirror codebase..
 */
var Icon = props => {
  var name = props.name;
  return /*#__PURE__*/jsx(IconBase, _objectSpread(_objectSpread({}, props), {}, {
    children: Tree2Element(Icons[name])
  }));
};

/**
 * The base icon as an svg with the icon context available
 */
var IconBase = props => {
  var renderSvg = context => {
    var _ref, _props$size, _props$color;

    var computedSize = (_ref = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : context.size) !== null && _ref !== void 0 ? _ref : '1em';
    var className;

    if (context.className) {
      className = context.className;
    }

    if (props.className) {
      className = (className ? "".concat(className, " ") : '') + props.className;
    }

    var title = props.title,
        svgProps = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/jsxs("svg", _objectSpread(_objectSpread(_objectSpread({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, context.attr), svgProps), {}, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : context.color
      }, context.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [title && /*#__PURE__*/jsx("title", {
        children: title
      }), props.children]
    }));
  };

  return /*#__PURE__*/jsx(IconContext.Consumer, {
    children: renderSvg
  });
};

export { GenIcon as G, Icon as I, IconBase as a };
